import actionTypes from '../actionTypes';

export const LOGIN_USER = actionTypes('LOGIN_USER');

export const LOGOUT_USER = actionTypes('LOGOUT_USER');

export const CLEAR_ERROR = actionTypes('CLEAR_ERROR');